import { useState, useEffect } from "react";
import Sidebar from '../../../componente/sidebar/index.jsx';
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';
import AWS from 'aws-sdk'
import { IMaskInput } from "react-imask";

function CadEmpresa() {
    const [lista, setlista] = useState([]);
    const [abusca, setabusca] = useState("");
    const [showform, setshowform] = useState(false);

    const [codempresa, setCodEmpresa] = useState(0);
    const [razaoSocial, setRazaoSocial] = useState(0);
    const [nomeFantasia, setNomeFantasia] = useState(0);
    const [CNPJ, setCNPJ] = useState("");
    const [IE, setIE] = useState("");
    const [CEP, setCEP] = useState("");
    const [endereco, setEndereco] = useState("");
    const [numero, setNumero] = useState("");
    const [complemento, setComplemento] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [UF, setUF] = useState("");
    const [email, setEmail] = useState("");
    const [telefone, setTelefone] = useState("");
    const [whatsapp, setWhatsApp] = useState("");
    const [logo, setLogo] = useState("");
    const [ativo, setAtivo] = useState("");

    const [novo, setnovo] = useState(false);

    const [isOpen, setIsOpen] = useState(false);

    const { selectedCompany, accessKey } = useAppContext(); // Acessa os dados do contexto

    // Configuração da AWS
    AWS.config.update({
        accessKeyId: 'AKIAY3NQW3W4CGLSXKDN', // AccountName
        secretAccessKey: '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', // AccountKey
        region: 'us-east-1', // Certifique-se de que esta é a região correta do bucket S3
    });

    const s3 = new AWS.S3();
    const bucketName = 'isolution'; // BucketName

    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        const params = {
            Bucket: bucketName,
            Key: `EstofariaRamos/ImagemEmpresa/${razaoSocial}_${file.name}`, // ObjectName + Nome do Arquivo
            Body: file,
            ContentType: file.type,
            ACL: 'public-read', // Permissão para tornar o arquivo acessível publicamente
        };

        try {
            // Upload para o S3
            const { Location } = await s3.upload(params).promise();
            setLogo(Location); // Armazena o link da imagem no estado edtfoto
            alert("Upload realizado com sucesso!");
        } catch (error) {
            console.error('Erro no upload:', error);
            alert("Erro ao realizar o upload.");
        }
    };

    const handleOpen = (cad) => {
        setCodEmpresa(cad.codempresa);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        Excluir();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    function ListarEmpresa() {
        api
            .get("v1/cadastro/empresa", {
                params: {
                    busca: abusca,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarEmpresa();
        },
        [abusca, selectedCompany]
    );

    function Cadastrar() {
        api
            .post(
                "v1/cadastro/empresa",
                {
                    razaosocial: razaoSocial,
                    nomefantasia: nomeFantasia,
                    cnpj: CNPJ,
                    ie: IE,
                    cep: CEP,
                    endereco,
                    numero,
                    complemento,
                    bairro,
                    cidade,
                    uf: UF,
                    email,
                    telefone,
                    whatsapp,
                    logo,
                    ativo,
                    excluido: "N"
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarEmpresa();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Editar() {
        api
            .put(
                "v1/cadastro/empresa",
                {
                    razaosocial: razaoSocial,
                    nomefantasia: nomeFantasia,
                    cnpj: CNPJ,
                    ie: IE,
                    cep: CEP,
                    endereco,
                    numero,
                    complemento,
                    bairro,
                    cidade,
                    uf: UF,
                    email,
                    telefone,
                    whatsapp,
                    logo,
                    ativo,
                    codempresa
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarEmpresa();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Excluir() {
        api
            .delete("v1/cadastro/empresa", {
                params: {
                    codempresa,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarEmpresa();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    function closeModal() {
        setshowform(false);
    }

    function openModalNovo() {
        setshowform(true);
        setnovo(true);

        setCodEmpresa(0);
        setRazaoSocial("");
        setNomeFantasia("");
        setCNPJ("");
        setIE("");
        setCEP("");
        setEndereco("");
        setNumero("");
        setComplemento("");
        setBairro("");
        setCidade("");
        setUF("");
        setEmail("");
        setTelefone("");
        setWhatsApp("");
        setLogo("");
        setAtivo("S");
    }

    function openModalEditar(cad) {
        setshowform(true);
        setnovo(false);

        setCodEmpresa(cad.codempresa);
        setRazaoSocial(cad.razaosocial);
        setNomeFantasia(cad.nomefantasia);
        setCNPJ(cad.cnpj);
        setIE(cad.ie);
        setCEP(cad.cep);
        setEndereco(cad.endereco);
        setNumero(cad.numero);
        setComplemento(cad.complemento);
        setBairro(cad.bairro);
        setCidade(cad.cidade);
        setUF(cad.uf);
        setEmail(cad.email);
        setTelefone(cad.telefone);
        setWhatsApp(cad.whatsapp);
        setLogo(cad.logo);
        setAtivo(cad.ativo);
    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <div className="content-container">
                    <div className="container-fluid">
                        <div>
                            <div>
                                <PopUp isOpen={isOpen} onClose={handleClose}>
                                    <h2>Verificação</h2>
                                    <p>Tem certeza que deseja excluir esse registro?</p>

                                    <div className="row">
                                        <div className="col-12 mt-3 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2"
                                                onClick={handleConfirma}
                                            >
                                                Sim
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={handleClose}>
                                                Não
                                            </button>
                                        </div>
                                    </div>
                                </PopUp>
                            </div>

                            <Modal
                                isOpen={showform}
                                onRequestClose={closeModal}
                                overlayClassName="modal-overlay"
                                className="modal-content modal-xl"
                            >
                                <div className="container-fluid h-100">
                                    <div className="modal-header">
                                        {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                        <button type="button" className="btn-close" onClick={closeModal}></button>
                                    </div>

                                    <div className="modal-body">
                                        <form>
                                            <div className="row">
                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="razaosocial" className="form-label">
                                                        Razão Social
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="razaosocial"
                                                        className="form-control"
                                                        placeholder="Razão Social"
                                                        value={razaoSocial}
                                                        onChange={(e) => setRazaoSocial(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="nomefantasia" className="form-label">
                                                        Nome Fantasia
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="nomefantasia"
                                                        className="form-control"
                                                        placeholder="Nome Fantasia"
                                                        value={nomeFantasia}
                                                        onChange={(e) => setNomeFantasia(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                                    <label htmlFor="cnpj" className="form-label">
                                                        CNPJ
                                                    </label>
                                                    <IMaskInput
                                                        mask={"00.000.000/0000-00"}
                                                        radix="."
                                                        id="cnpj"
                                                        className="form-control"
                                                        placeholder="CNPJ"
                                                        value={CNPJ}
                                                        onAccept={(value) => setCNPJ(value)}
                                                    />                                                    
                                                </div>

                                                <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                                    <label htmlFor="ie" className="form-label">
                                                        Insc. Estadual
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="ie"
                                                        className="form-control"
                                                        placeholder="Insc. Estadual"
                                                        value={IE}
                                                        onChange={(e) => setIE(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                                    <label htmlFor="cep" className="form-label">
                                                        CEP
                                                    </label>
                                                    <IMaskInput
                                                        mask={"00000-000"}
                                                        radix="."
                                                        id="cep"
                                                        className="form-control"
                                                        placeholder="CEP"
                                                        value={CEP}
                                                        onAccept={(value) => setCEP(value)}
                                                    />                                                     
                                                </div>

                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="endereco" className="form-label">
                                                        Endereço
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="endereco"
                                                        className="form-control"
                                                        placeholder="Endereço"
                                                        value={endereco}
                                                        onChange={(e) => setEndereco(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12">
                                                    <label htmlFor="numero" className="form-label">
                                                        Número
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="numero"
                                                        className="form-control"
                                                        placeholder="Número"
                                                        value={numero}
                                                        onChange={(e) => setNumero(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                                    <label htmlFor="complemento" className="form-label">
                                                        Complemento
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="complemento"
                                                        className="form-control"
                                                        placeholder="Complemento"
                                                        value={complemento}
                                                        onChange={(e) => setComplemento(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12">
                                                    <label htmlFor="bairro" className="form-label">
                                                        Bairro
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="bairro"
                                                        className="form-control"
                                                        placeholder="Bairro"
                                                        value={bairro}
                                                        onChange={(e) => setBairro(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <label htmlFor="cidade" className="form-label">
                                                        Cidade
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="cidade"
                                                        className="form-control"
                                                        placeholder="Cidade"
                                                        value={cidade}
                                                        onChange={(e) => setCidade(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-xl-1 col-lg-1 col-md-6 col-sm-12">
                                                    <label htmlFor="uf" className="form-label">
                                                        UF
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="uf"
                                                        className="form-control"
                                                        placeholder="UF"
                                                        value={UF}
                                                        onChange={(e) => setUF(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                    <label htmlFor="email" className="form-label">
                                                        Email
                                                    </label>
                                                    <input
                                                        type="email"
                                                        id="email"
                                                        className="form-control"
                                                        placeholder="Email"
                                                        value={email}
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                                                    <label htmlFor="telefone" className="form-label">
                                                        Telefone
                                                    </label>
                                                    <IMaskInput
                                                        mask={"(00) 00000-0000"}
                                                        radix="."
                                                        id="telefone"
                                                        className="form-control"
                                                        placeholder="Telefone"
                                                        value={telefone}
                                                        onAccept={(value) => setTelefone(value)}
                                                    />                                                    
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12">
                                                    <label htmlFor="whatsapp" className="form-label">
                                                        WhatsApp
                                                    </label>
                                                    <IMaskInput
                                                        mask={"(00) 00000-0000"}
                                                        radix="."
                                                        id="whatsapp"
                                                        className="form-control"
                                                        placeholder="WhatsApp"
                                                        value={whatsapp}
                                                        onAccept={(value) => setWhatsApp(value)}
                                                    />                                                    
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-10 col-lg-10 col-md-9 col-sm-12">
                                                    <br />
                                                    <input type="file" onChange={handleFileUpload} />
                                                    <p>Link da Foto: <a href={logo} target="_blank" rel="noopener noreferrer">{logo}</a></p>
                                                </div>

                                                <div className="col-xl-2 col-lg-2 col-md-3 col-sm-12">
                                                    <div>
                                                        <label htmlFor="ativo1" className="form-label">
                                                            Ativo
                                                        </label>
                                                        <br />
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="ativo"
                                                                value="S"
                                                                onChange={(e) => setAtivo(e.target.value)}
                                                                checked={ativo === "S"}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                for="inlineRadio1"
                                                            >
                                                                Sim
                                                            </label>
                                                        </div>

                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="ativo"
                                                                value="N"
                                                                onChange={(e) => setAtivo(e.target.value)}
                                                                checked={ativo === "N"}
                                                            />
                                                            <label className="form-check-label" htmlfor="ativo2">
                                                                Não
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-danger" onClick={closeModal}>
                                            Cancelar
                                        </button>
                                        <button type="button" className="btn btn-success" onClick={Salvar}>
                                            Salvar
                                        </button>

                                    </div>
                                </div>
                            </Modal>
                        </div>

                        <div className="row">
                            <h1 className="ms-4">Cadastro de Empresa</h1>
                            <p className="ms-4">Rotina para cadastrar as empresas ou filiais</p>
                            <hr />
                        </div>

                        <div className="row">
                            <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                <label className="form-label" htmlFor="busca">
                                    Busque aqui
                                </label>
                                <input
                                    type="text"
                                    placeholder="Buscar por: Código, Razão Social, Nome Fantasia ou CNPJ"
                                    name="busca"
                                    id="busca"
                                    className="form-control"
                                    value={abusca}
                                    onChange={(e) => setabusca(e.target.value)}
                                />
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
                                <button
                                    type="button"
                                    className="btn btn-success btnnovo"
                                    onClick={() => openModalNovo()}
                                >
                                    Novo
                                </button>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <hr />
                        </div>

                        <div className="row tabela">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>CNPJ</th>
                                        <th>Razão Social</th>
                                        <th>Nome Fantasia</th>
                                        <th>Bairro</th>
                                        <th>Cidade</th>
                                        <th>WhatsApp</th>
                                        <th className="acao">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lista.map(function (item, index) {
                                        return (
                                            <tr key={index}>
                                                <th>{item.codempresa}</th>
                                                <th>{item.cnpj}</th>
                                                <th>{item.razaosocial}</th>
                                                <th>{item.nomefantasia}</th>
                                                <th>{item.bairro}</th>
                                                <th>{item.cidade}</th>
                                                <th>{item.whatsapp}</th>
                                                <th>
                                                    <div className="d-flex justify-content-center">
                                                        <button
                                                            type="button"
                                                            className="btn fa-regular fa-pen-to-square"
                                                            onClick={() => openModalEditar(item)}
                                                        ></button>
                                                        <button
                                                            type="button"
                                                            className="btn fa-solid fa-trash"
                                                            onClick={() => handleOpen(item)}
                                                        ></button>
                                                    </div>
                                                </th>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={8}>Quantidade de Registros: {lista.length}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CadEmpresa;
